import React from "react";

function NoticeBar({ notices = [] }) {
  const items = Array.isArray(notices) && notices.length > 0 ? notices : [{ content: "Admission Open for 2026" }];
  const totalCharacters = items.reduce((count, notice) => {
    const plainText = (notice.content || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    return count + plainText.length;
  }, 0);
  const scrollDuration = Math.max(14, Math.ceil(totalCharacters * 0.24));

  return (
    <section className="notice-modern">
      <div className="notice-modern__label">
        <i className="bi bi-megaphone-fill"></i>
        Notice
      </div>

      <div className="notice-modern__track">
        <div className="notice-modern__text" style={{ "--notice-scroll-duration": `${scrollDuration}s` }}>
          {items.map((notice, index) => (
            <span key={`${index}-${notice.content || "notice"}`} className="notice-modern__item">
              <span dangerouslySetInnerHTML={{ __html: notice.content || "" }} />
              {index !== items.length - 1 ? <span className="notice-modern__separator">|</span> : null}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NoticeBar;
